export { default } from './mounted';
